import { defineComponent, h } from 'vue';
let currentId = 0;
const props = {
    title: String,
};
/**
 * Factory to create Icon class components for consumers
 */
export function createIcon({ name, xOffset = 0, yOffset = 0, width, height, svgPath, }) {
    const Icon = defineComponent({
        name,
        render() {
            const id = `icon-title-${currentId++}`;
            const viewBox = [xOffset, yOffset, width, height].join(' ');
            const children = [];
            if (this.title) {
                children.push(h('title', { id }, this.title));
            }
            children.push(h('path', { d: svgPath }));
            return h('svg', {
                class: 'pf-v6-svg',
                fill: 'currentColor',
                viewBox,
                'aria-labelled-by': this.title ? id : undefined,
                'aria-hidden': this.title ? undefined : true,
                role: 'img',
                width: '1em',
                height: '1em',
            }, children);
        },
    });
    Icon.props = props;
    return Icon;
}
//# sourceMappingURL=createIcon.js.map